import Backbone from 'backbone';

export default Backbone.Model.extend({
    defaults: {
        requireTaxid: ''
    },

    initialize: function () {
        this.on('change:requireTaxid', this.onRequireTaxIdChange, this);
    },

    onRequireTaxIdChange: function (model, value) {
        model.set('showTaxId', value === '1');
    }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/pages/checkout/checkoutAddressModel.js
 **/